export { MemberService } from '../services/member.service';

